import(/* webpackMode: "eager" */ "/repo/apps/backoffice/src/app/global-error.tsx");
